import type { CatalogProductSharedDisplayFieldsFragment } from '../api/shared.graphql.generated';
import type { CatalogItemTile } from '../Catalog.types';

export type FindMatchingProductByDimensionArgs = {
  /**
   * The initial product rendered in the product tile
   */
  parentProduct: CatalogItemTile;
  dimensionOptionId: string;
};

// NOTE: Temporary until color swatch API is up.
// Refer to https://withjoy.atlassian.net/browse/REG-2241 for usage
export const findMatchingProductByDimension = (args: FindMatchingProductByDimensionArgs): Maybe<CatalogProductSharedDisplayFieldsFragment> => {
  const { parentProduct, dimensionOptionId: targetDimensionOptionId } = args;

  if (parentProduct.group?.tileViewDimension?.title === 'Color') {
    // Find first relevant product
    return parentProduct.group.items.find(item => {
      // Find first match
      return item.groupDimensionOptions.some(dimensionOption => dimensionOption.id === targetDimensionOptionId);
    });
  }
  return null;
};
